import React, {
  MouseEventHandler,
  ReactElement,
  useEffect,
  useState,
} from 'react';

import { useAuth } from 'contexts/auth-context';
import useNav from 'hooks/nav';

import { BOOKING_SUMMARY_PATH } from 'constants/paths';

import UserInformation from './user-information';
import PassengerInformation from './passenger-information';

import './contact-details.scss';
import { useReservations } from 'contexts/reservations-context';
import { parksApi } from 'api/bestpark/parks';
import { useTranslate } from 'hooks/translate';
import { useQuery } from 'react-query';
import { BOOKING_PAGES } from 'constants/booking';

interface ContactDetailsProps {
  back: MouseEventHandler;
}

const screens = ['user-information', 'passenger-information'];

export default function ContactDetails({
  back,
}: ContactDetailsProps): ReactElement {
  const { locale } = useTranslate();
  const { goTo } = useNav();
  const { authState } = useAuth();
  const [currentScreen, setCurrentScreen] = useState(screens[0]);
  const { parkId, setPage, page } = useReservations();

  // Get park data
  const { data: parkDetail } = useQuery(
    ['park', String(parkId), locale],
    parksApi.getPark,
  );
  const hostedCamp = !!parkDetail?.hostUrl;
  useEffect(() => {
    setCurrentScreen(screens[page === BOOKING_PAGES.CONTACT_DETAILS ? 0 : 1]);
  }, [page]);

  const onBackButtonClick = (event: any): void => {
    if (
      currentScreen === screens[1] ||
      !parkDetail?.requirePassengerDeclaration
    ) {
      setPage(BOOKING_PAGES.CONTACT_DETAILS);
    } else {
      back(event);
    }
  };
  const onNextButtonClick = (): void => {
    if (
      parkDetail?.requirePassengerDeclaration &&
      currentScreen === screens[0]
    ) {
      setPage(BOOKING_PAGES.PASSENGER_INFO);
    } else {
      goTo(`${BOOKING_SUMMARY_PATH}`);
      setPage(BOOKING_PAGES.BOOKING_SUMMARY);
    }
  };

  return currentScreen === screens[0] ? (
    <UserInformation
      next={onNextButtonClick}
      user={authState?.userInfo}
      hostedCamp={hostedCamp}
    />
  ) : (
    <PassengerInformation
      user={authState?.userInfo}
      back={onBackButtonClick}
      next={onNextButtonClick}
      hostedCamp={hostedCamp}
    />
  );
}
